import { Row, Space, Radio, Button, Card } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import FurnishingErrorModal from './FurnishingErrorModal';
import AccountDetails from './FurnishingComponents/AccountDetails';
import usePageState from '../../../helpers/usePageState';
import { toWriteOff } from '../../../helpers/genericHelper';

function FurnishingComponent({
  bloomFurnishing = {},
  creditCards = {},
  userId,
  userSummary,
  refresh
}) {
  const [accountTypeFilter, setAccountTypeFilter] = usePageState('furnishing-account-type', 'cc');

  const [savedCcTab, setCcTabSelection] = usePageState('furnishing-cc-account', null);
  const [savedSbTab, setSbTabSelection] = usePageState('furnishing-sb-account', null);

  const creditCardFurnishingAccounts = bloomFurnishing?.creditCardFurnishingAccounts || [];
  const savingsBuilderFurnishingAccounts = bloomFurnishing?.savingsBuilderFurnishingAccounts || [];

  const fullName = `${userSummary?.firstName} ${userSummary?.lastName}`;

  const isCC = accountTypeFilter !== 'sb';
  const accounts = isCC ? creditCardFurnishingAccounts : savingsBuilderFurnishingAccounts;
  const savedAccountId = isCC ? savedCcTab : savedSbTab;
  const setSavedAccountId = isCC ? setCcTabSelection : setSbTabSelection;
  const selectedAccount = accounts.find((account) => account.accountId === savedAccountId) ?? accounts[0];

  // One tab per tradeline, labelled with its open date and status, the same as the original design
  const tradelineTabs = accounts.map((account) => ({
    key: account.accountId,
    tab: <div className="furnish-tradeline-tab">
      {account.openDate || 'N/A'}
      <small>({(isCC ? account.accountStatus : toWriteOff(account.accountStatus)) || 'UNKNOWN'})</small>
    </div>
  }));

  return (
    <div className="furnish-page">
      {/* Product and page actions */}
      <div className="furnish-toolbar">
        <Radio.Group value={isCC ? 'cc' : 'sb'} onChange={(e) => setAccountTypeFilter(e.target.value)} buttonStyle="solid">
          <Radio.Button value="cc">Credit Card ({creditCardFurnishingAccounts.length})</Radio.Button>
          <Radio.Button value="sb">Save &amp; Build ({savingsBuilderFurnishingAccounts.length})</Radio.Button>
        </Radio.Group>
        <Space size={8} className="furnish-toolbar-actions">
          <Button icon={<SyncOutlined />} onClick={refresh}>Refresh</Button>
          <FurnishingErrorModal />
        </Space>
      </div>

      {/* Tradelines */}
      <Card
        size="small"
        className="furnish-card furnish-tradelines"
        title={isCC ? 'Credit Cards' : 'Savings Builder'}
        tabList={tradelineTabs}
        activeTabKey={selectedAccount?.accountId}
        onTabChange={setSavedAccountId}>
        {selectedAccount
          ? <AccountDetails
              key={selectedAccount.accountId}
              fullName={fullName}
              account={selectedAccount}
              isCC={isCC}
              refresh={refresh}
              creditCards={creditCards}
              userId={userId}/>
          : <Row className="no-data-card">No data found</Row>}
      </Card>
    </div>
  );
}

export default FurnishingComponent;
